:host {
  display: block;
}

.select {
  position: relative;

  select {
    font-family: var(--primary-font);
    font-weight: var(--font-weight-light);
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    width: 100%;
    height: 25px;
    padding-left: 5px;
    padding-right: 15px;
    background: var(--color-white);
    border: 1px solid var(--color-silver);
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none;
    text-transform: uppercase;
    cursor: pointer;
    color: var(--color-nero);

    option {
      font-weight: var(--font-weight-light);
    }
  }

  &__arrow {
    position: absolute;
    top: 1px;
    right: 0;
    width: 25px;
    height: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    pointer-events: none;
  }

  &.size-md {

    select {
      height: 30px;
      font-weight: var(--font-weight-regular);
      font-size: 14px;
      padding-left: 10px;
      color: var(--color-nero);
    }

    .select__arrow {
      font-size: 14px;
      height: 30px;
      right: 10px;
    }

  }

  &.size-lg {

    select {
      height: 40px;
      font-weight: var(--font-weight-regular);
      font-size: 16px;
      padding-left: 10px;
      color: var(--color-nero);
    }

    .select__arrow {
      font-size: 14px;
      height: 40px;
      right: 10px;
    }
  }
}
